import { useQuery } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';
import type { RunListFilter } from '../types/retentionAdmin';

/**
 * GET /api/eraf/retention-admin/runs — 실행 이력 (RETENTION_READ)
 * queryKey: ['retention-admin', 'runs', filters]
 */
export function useRetentionRuns(filters: RunListFilter) {
  return useQuery({
    queryKey: ['retention-admin', 'runs', filters],
    queryFn: () =>
      retentionAdminApi.listRuns({
        policyName: filters.policyName || undefined,
        status: filters.status || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'startedAt,desc',
      }),
    staleTime: 30_000,
  });
}
